import React, {useContext, useEffect} from "react";
import "./index.scss";
import {Formik} from "formik";
import {FormRow} from "../../../../components/Form/FormRow";
import {FormItem} from "../../../../components/Form/FormItem";
import {useMediaQuery} from "@material-ui/core";
import {SelectOneRadioOld} from "../../../../components/inputs/RadioGroupOld";
import {SimpleTooltip} from "../../../../components/SimpleTooltip";
import TravelProgram, {IAdvertiseOption} from "../../TravelProgram";
import {TravelQuotationPackage} from "../../../../model/quoationPackage";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../../contexts/TravelQuotationContext";
import {TravelQuotation} from "../../../../model/quotation";
import * as _ from 'lodash';
import {strings} from "../../../../strings/strings";
import {StepControls} from "../../../../components/Scenario/Step/StepControls";
import * as log from "../../../../utils/log";
import {LogFunctionalModule} from "../../../../utils/log";
import { useHotjar } from "../../../../utils/hooks/useHotjar";

const optimal: IAdvertiseOption[] = [
    {
        type: 'check',
        text: strings.optimalAdvertise1,
        isMainPackageOption: true
    },
    {
        type: 'check',
        text: strings.optimalAdvertise2,
        tooltip: strings.optimalAdvertise2Tooltip
    },
    {
        type: 'check',
        text: strings.optimalAdvertise3,
        tooltip: strings.optimalAdvertise3Tooltip
    },
    {
        type: 'check',
        text: strings.optimalAdvertise4,
        tooltip: strings.optimalAdvertise4Tooltip
    },
    {
        type: 'check',
        text: strings.optimalAdvertise5,
        tooltip: strings.optimalAdvertise5Tooltip
    },
    {
        type: 'check',
        text: strings.optimalAdvertise6,
        tooltip: strings.optimalAdvertise6Tooltip
    },
    {
        type: 'check',
        text: strings.optimalAdvertise7,
        tooltip: strings.optimalAdvertise7Tooltip
    },
    {
        type: 'check',
        text: strings.classicAdvertise3,
        isNewOption: true
    }
]

const premium: IAdvertiseOption[] = [
    {
        type: 'check',
        text: strings.premiumAdvertise1
    },
    {
        type: 'plus',
        text: strings.premiumAdvertise2,
        tooltip: strings.premiumAdvertise2Tooltip
    },
    {
        type: 'plus',
        text: strings.premiumAdvertise3,
        tooltip: strings.premiumAdvertise3Tooltip
    },
    {
        type: 'plus',
        text: strings.premiumAdvertise4,
        tooltip: strings.premiumAdvertise4Tooltip
    },
    {
        type: 'plus',
        text: strings.premiumAdvertise5,
        tooltip: strings.premiumAdvertise5Tooltip
    },
    {
        type: 'check',
        text: strings.classicAdvertise3,
        isNewOption: true
    }
]

const classic: IAdvertiseOption[] = [
    {
        type: 'check',
        text: strings.classicAdvertise1,
        isMainPackageOption: true
    },
    {
        type: 'check',
        text: strings.classicAdvertise2,
        tooltip: strings.classicAdvertise2Tooltip
    },
    {
        type: 'check',
        text: strings.classicAdvertise3,
        isNewOption: true
    }
]

const sumInsuredOptions = [
    {
        value: 30000,
        label: '30 000 EUR'
    },
    {
        value: 50000,
        label: '50 000 EUR'
    }
]

export const packages = [
    {
        value: "OPTIMAL",
        title: strings.optimalAdvertiseTitle
    },
    {
        value: "CLASSIC",
        title: strings.classicAdvertiseTitle
    },
    {
        value: "PREMIUM",
        title: strings.premiumAdvertiseTitle
    },
]

export interface ISelectProgramFormProps {
    packages: TravelQuotationPackage[]
    onPackageSelect: (event: any) => void
    onBackStep: () => void
    onSumInsuredSelect: (submittedQuotation: TravelQuotation) => void
}


export const SelectProgramForm: React.FC<ISelectProgramFormProps> = ({packages, onPackageSelect, onBackStep, onSumInsuredSelect}) => {
    const {quotation, setQuotation, type} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const { trackHotjar } = useHotjar()

    useEffect(() => {
        trackHotjar("program", type)
        setQuotation( quotation => {
            const quotationClone = _.cloneDeep(quotation)
            const updatedQuotation = setPackageToQuotation(quotationClone, quotation.travelWebContract.travelPackage)
            return updatedQuotation
        })
    }, [])

    useEffect(() => {
        let event = 'travel_calculating';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
    }, []);

    const setPackageToQuotation = (quotation: TravelQuotation, packageClicked: "OPTIMAL" | "CLASSIC" | "PREMIUM") => {
        const curPack = packages.find(item => item.travelPackage === packageClicked) || packages[0]
        quotation.travelWebContract.travelPackage = packageClicked
        quotation.totalPremium = curPack.premium
        quotation.travelWebContract.premium = curPack.premium
        quotation.status = "TARIFFICATION"
        return quotation
    }

    const onPackageChange = (packageClicked: "OPTIMAL" | "CLASSIC" | "PREMIUM") => {
        const date = new Date();
        log.sendLog(date, LogFunctionalModule.STORE_TRAVEL, 'INFO',"ON_PACKAGE_CLICK", [{packageClicked: packageClicked}], '')
        const updatedQuotation = _.cloneDeep(quotation)
        const resultQuotation = setPackageToQuotation(updatedQuotation, packageClicked)
        setQuotation(resultQuotation)
    }

    const saveTempValues = (quotation:TravelQuotation) => {
        if( quotation ){
            localStorage.setItem("TRAVEL_quotation", JSON.stringify(quotation))
        }
    }

    return (
        <Formik initialValues={null}
                onSubmit={(values) => {

                }}
                validateOnChange={false}
                validateOnBlur={true}
        >
            {formProps => {
                saveTempValues(formProps.values)
                return (
                    <form className={"select-program-step"}>

                        <h3 className={'mb-50'}>Страхова сума:</h3>

                        <FormRow className={'select-program-step_sum-options select-program-step_row'}>
                            <FormItem  colspan={isMobile ? 1 : 3}>
                                <SelectOneRadioOld getLabel={val => {
                                                    const lb = sumInsuredOptions.filter(item => item.value === val)
                                                    return lb[0].label
                                                }}
                                                options={[30000, 50000]}
                                                value={quotation.travelWebContract.sumInsured}
                                                onChangeListener={(val) => {
                                                    const updatedQuotation = {
                                                        ...quotation,
                                                        travelWebContract: {
                                                            ...quotation.travelWebContract,
                                                            sumInsured: parseInt(val)
                                                        }
                                                    }
                                                    onSumInsuredSelect(updatedQuotation)
                                                }}/>
                            </FormItem>
                        </FormRow>

                        <FormRow className={`select-program-step_sum-options ${isMobile ? 'select-program-step_row_mobile' : 'select-program-step_row'}`}>
                            <FormItem  colspan={isMobile ? 1 : 3}>
                                <SimpleTooltip id={'travel_is'}
                                               placement={'bottom'}
                                               title={
                                                   <div className={'tooltip-item'}>

                                                       <span><p>{strings.insuredSum}</p>{strings.insuredSum2}</span>
                                                   </div>
                                               }>
                                    {strings.whatIsInsuredSum}
                                </SimpleTooltip>
                            </FormItem>
                        </FormRow>

                        <h3 className={'mb-50'}>{strings.chooseYourProgram}</h3>

                        <FormRow className={'select-program-step_row-program'} columns={1}>
                            {
                                packages.map(pack => {
                                    if (pack.travelPackage === 'OPTIMAL') {
                                        return (
                                        <TravelProgram name={pack.travelPackage} onSelectButtonClick={onPackageChange} optionsShow={4}
                                                       moreDetailsText={strings.learnMore}
                                                       moreDetailsAction={() => {window.open(`${process.env.PUBLIC_URL}/resources/product_conditions_travel.pdf`);}}
                                                       selected={quotation.travelWebContract.travelPackage === 'OPTIMAL'} title={strings.optimalAdvertiseTitle} size={isMobile ? 'small' : "big"} advertise={optimal} price={pack.premium}/>
                                        )
                                    }})
                            }
                        </FormRow>

                        <FormRow className={'select-program-step_row select-program-step_rowSelect'} columns={isMobile ? 1 : 2}>
                            {
                                packages.map(pack => {
                                    if (pack.travelPackage === 'PREMIUM') {
                                        return (
                                            <TravelProgram name={pack.travelPackage} onSelectButtonClick={onPackageChange} selected={quotation.travelWebContract.travelPackage === 'PREMIUM'} title={strings.premiumAdvertiseTitle} size={"small"} advertise={premium} price={pack.premium}/>
                                        )
                                    }})
                            }
                            {
                                packages.map(pack => {
                                    if (pack.travelPackage === 'CLASSIC') {
                                        return (
                                            <TravelProgram name={pack.travelPackage} onSelectButtonClick={onPackageChange} selected={quotation.travelWebContract.travelPackage === 'CLASSIC'} title={strings.classicAdvertiseTitle} size={"small"} advertise={classic} price={pack.premium}/>
                                        )
                                    }})
                            }
                        </FormRow>

                        <StepControls onBack={() => {
                            const date = new Date();
                            log.sendLog(date, LogFunctionalModule.STORE_TRAVEL, 'INFO',"SELECT_PROGRAM_FORM_BACK_HANDLER", [{quotation: quotation, formProps: formProps}], '')
                            onBackStep()
                        }} onNext={(event) => {
                            const date = new Date();
                            log.sendLog(date, LogFunctionalModule.STORE_TRAVEL, 'INFO',"SELECT_PROGRAM_FORM_NEXT_HANDLER", [{quotation: quotation, formProps: formProps}], '')
                            onPackageSelect(event)
                        }} leftSteps={2} nextIsAvailable={true}/>
                    </form>
                )
            }}
        </Formik>
    )
};
